import wcmatch from 'wildcard-match';

export default defineNuxtRouteMiddleware((to) => {
  if (wcmatch('/app/**')(to.path)) {
    setPageLayout('account');
  } else if (wcmatch('/admin/**')(to.path)) {
    setPageLayout('admin');
  }
});
